module.exports = __webpack_public_path__ + "img/school_part2_intro.bd6f1d09.png";